interface ConfiguratorContext {
	getAttribute(name: string): string | null;
}

interface EmbedViewerSource {
	modelData: string;
	additionalData: Record<string, unknown>;
	modelURL: string;
}

declare const ShedPro: {
	new (): {
		getIframeElement(): ConfiguratorContext | HTMLElement | null;
		building_details_v2(finalData: Record<string, unknown>, additionalData: Record<string, unknown>, hash: string, modelURL: string): Record<string, unknown>;
	};
};

export const handleEmbedViewerData = (source: EmbedViewerSource): Record<string, unknown> => {
	const configurator = new ShedPro();
	const configuratorContext: ConfiguratorContext = {
		getAttribute(name: string) {
			return name === 'src' ? window.location.href : null;
		},
	};

	configurator.getIframeElement = () => configuratorContext;

	const finalData = JSON.parse(atob(source.modelData));
	const additionalData = { ...source.additionalData, show_price: 1 };
	return {
		building_details_v2: configurator.building_details_v2(finalData, additionalData, btoa(source.modelURL), source.modelURL),
	};
};

export const setEmbedViewerFormData = (data: Record<string, unknown>): void => {
	const form = document.querySelector<HTMLFormElement>('form.cart');
	const input = form.querySelector<HTMLInputElement>('input[name="ssb-embed-viewer-data"]');
	const buildingDetails = { ...(data.building_details_v2 as Record<string, unknown>) };
	if (Array.isArray(buildingDetails.images)) {
		buildingDetails.images = buildingDetails.images.map((image: Record<string, unknown>) => {
			const imageMetadata = { ...image };
			delete imageMetadata.value;
			return imageMetadata;
		});
	}
	// The popup checkout encodes the form as base64, which requires ASCII text.
	input.value = JSON.stringify(buildingDetails).replace(/[\u007f-\uffff]/g, (character) =>
		'\\u' + ('0000' + character.charCodeAt(0).toString(16)).slice(-4),
	);
};
